import React from 'react'
import Header from '../components/Header'
import Demo from '../components/Navbar'

const Wifi = () => {
    return (
        <div>
            <Header />
            {/* <section id="heros" className="heros1 section dark-background" data-aos="fade-right" data-aos-delay="100">

                <img src="/wifi.png" alt="" data-aos="fade-in" />



            </section> */}
            <div className='heros1' >
                <img src="/wifi.png" alt="" data-aos="fade-in" />

                {/* <div className="container text-center " >
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <h2 className=''>Emergence of Wi-Fi 7 Technology: <br />
                                A Game-Changer in <br />
                                Wireless Connectivity
                            </h2>
                        </div>
                    </div>
                </div> */}
            </div>     <section
                id="testimonials-section sect-paddings"
                className="testimonials-section  at-bg-cover d-flex  align-items-center paragraph paragraph--type--quote paragraph--view-mode--default"
                style={{ background: "url(/feature2.png)" }}
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center text-center">
                        <div
                            className="col-12 col-lg-10 at-maxw-1075"
                        // style={{ background: "#362358" , fontFamily: "proxima-nova" ,lineHeight: "1.5" }}
                        >
                            <blockquote className="text-start ">
                                {/* <div className="svg-holder">
                                    <svg
                                        width={107}
                                        height={71}
                                        viewBox="0 0 107 71"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M107 51.8969C107 57.2033 104.965 61.7668 100.895 65.5875C97.039 69.1958 92.2192 71 86.4354 71C78.5095 71 71.8689 68.2407 66.5135 62.722C61.3724 57.2033 58.8018 50.0927 58.8018 41.3901C58.8018 25.4709 65.014 14.1151 77.4384 7.32287C86.4354 2.44096 93.7187 0 99.2883 0C101.645 0 102.823 0.84903 102.823 2.54709C102.823 4.03288 101.538 5.09417 98.967 5.73094C81.1872 10.4006 72.2973 19.2093 72.2973 32.157C72.2973 37.8879 73.7968 42.7698 76.7958 46.8027C77.2242 39.5859 81.8298 35.9776 90.6126 35.9776C95.3253 35.9776 99.1812 37.5695 102.18 40.7534C105.393 43.725 107 47.4395 107 51.8969ZM47.8769 51.8969C47.8769 57.2033 45.8418 61.7668 41.7718 65.5875C37.9159 69.1958 33.2032 71 27.6336 71C19.4935 71 12.8529 68.2407 7.71171 62.722C2.57057 56.991 0 49.7743 0 41.0718C0 25.3647 6.21221 14.1151 18.6366 7.32287C27.6336 2.44096 34.8098 0 40.1652 0C42.5215 0 43.6997 0.84903 43.6997 2.54709C43.6997 4.03288 42.4144 5.09417 39.8438 5.73094C22.2783 10.4006 13.4955 19.3154 13.4955 32.4753C13.4955 37.994 14.995 42.7698 17.994 46.8027C18.4224 39.5859 22.9209 35.9776 31.4895 35.9776C36.2022 35.9776 40.0581 37.5695 43.0571 40.7534C46.2703 43.725 47.8769 47.4395 47.8769 51.8969Z"
                                            fill="#161616"
                                        />
                                    </svg>
                                </div> */}
                                <h4 className="fw-normal mt-md-5 mt-3 mb-4 at-lh-1pt7">
                                    <p className='fs-6'>
                                        In the fast-paced world of wireless communication, technology continuously evolves to meet the increasing demands for faster speeds, lower latency, and enhanced connectivity. Wi-Fi 7, the next generation in wireless standards, is set to revolutionize the way we experience wireless networks. Officially known as IEEE 802.11be, Wi-Fi 7 promises to deliver unprecedented speed, bandwidth, and efficiency, making it a key enabler for the future of digital experiences.

                                    </p>
                                </h4>

                            </blockquote>
                        </div>
                    </div>
                </div>
            </section>
            {/* <div className='network ' style={{ background: "#fff", color: "#000" }} >

                <p className='text-dark fw-700 fs-5 para'>In the fast-paced world of wireless communication, technology continuously evolves to meet the increasing demands for faster speeds, lower latency, and enhanced connectivity. Wi-Fi 7, the next generation in wireless standards, is set to revolutionize the way we experience wireless networks. Officially known as IEEE 802.11be, Wi-Fi 7 promises to deliver unprecedented speed, bandwidth, and efficiency, making it a key enabler for the future of digital experiences.

                </p>
            </div> */}
            <div className='container'  >
                <img src='/wifi1.png' className='w-100' alt='wifi1' /> <br />
                <p className='fs-6' data-aos="fade-right" data-aos-delay="100">


                    <span style={{ color: "#7F3E98" }}> 1. Higher Speeds:</span> <br />
                    Wi-Fi 7 is designed to deliver speeds up to 46 Gbps, which is a massive jump from Wi-Fi 6's maximum of around 9.6 Gbps. This improvement is due to advanced modulation schemes like 4096-QAM (Quadrature Amplitude Modulation), which can transmit more data in the same bandwidth.
                </p> <br />
                <p className='fs-6' data-aos="fade-right" data-aos-delay="100">
                    <span style={{ color: "#7F3E98" }}>  2. Increased Bandwidth and Multi-Link Operation (MLO):</span> <br />
                    Wi-Fi 7 supports wider channel bandwidth, up to 320 MHz, doubling the 160 MHz channels offered by Wi-Fi 6. This wider bandwidth allows for faster data transfers and more simultaneous connections. Additionally, Multi-Link Operation (MLO) enables the use of multiple frequency bands (2.4 GHz, 5 GHz, and 6 GHz) simultaneously for a more robust and seamless connection. This will significantly reduce latency and improve the reliability of connections in dense environments like smart cities or stadiums.

                </p> <br />
                <p className='fs-6' data-aos="fade-up" data-aos-delay="100">


                    <span style={{ color: "#7F3E98" }}>  3. Reduced Latency:</span> <br />

                    For applications such as VR/AR, real-time gaming, and high-definition video conferencing, low latency is critical. Wi-Fi 7’s target wake time (TWT) and multi-access point coordination features are designed to minimize latency and reduce interference, ensuring smooth, real-time interactions.


                </p>
                <p className='fs-6' data-aos="fade-up" data-aos-delay="100">


                    <span style={{ color: "#7F3E98" }}>
                        4. Enhanced Device Density:</span> <br />
                    With the increasing number of devices connected to a single network (smart homes, IoT devices, etc.), Wi-Fi 7 is built to manage more connected devices without a decline in performance. It optimizes how it schedules communication with devices to ensure that everyone gets a piece of the bandwidth efficiently, even in high-density environments.

                </p> <br /> <br />
                <p className='fs-6' data-aos="fade-up" data-aos-delay="100">


                    <span style={{ color: "#7F3E98" }}>
                        5. Improved Spectrum Efficiency:</span> <br />

                    Wi-Fi 7 introduces new ways of utilizing the spectrum more effectively. Coloring schemes and coordinated beamforming allow for better spatial reuse of channels, reducing interference and maximizing spectrum efficiency. These techniques enable networks to handle more users and devices simultaneously without significant performance drops.




                </p> <br /> <br />
                <img src='/wifi2.png' data-aos="fade-right" data-aos-delay="100" className='w-100' alt='wifi1' /> <br />
                <p className='fs-6' data-aos="fade-right" data-aos-delay="100">


                    <span style={{ color: "#7F3E98" }}>

                        1. 4K/8K Streaming and Beyond:</span> <br />
                    With ultra-fast speeds and low latency, Wi-Fi 7 will support seamless streaming of 4K and 8K content across multiple devices without buffering or quality degradation. This will revolutionize home entertainment systems, media consumption, and content delivery services.
                </p> <br />
                <p className='fs-6' data-aos="fade-up" data-aos-delay="100">
                    <span style={{ color: "#7F3E98" }}>
                        2. Immersive Virtual and Augmented Reality:</span> <br />
                    Wi-Fi 7 supports wider channel bandwidth, up to 320 MHz, doubling the 160 MHz channels offered by Wi-Fi 6. This wider bandwidth allows for faster data transfers and more simultaneous connections. Additionally, Multi-Link Operation (MLO) enables the use of multiple frequency bands (2.4 GHz, 5 GHz, and 6 GHz) simultaneously for a more robust and seamless connection. This will significantly reduce latency and improve the reliability of connections in dense environments like smart cities or stadiums.

                </p> <br />
                <p className='fs-6' data-aos="fade-right" data-aos-delay="100">


                    <span style={{ color: "#7F3E98" }}>  3. Smart Cities and IoT:</span> <br />

                    For applications such as VR/AR, real-time gaming, and high-definition video conferencing, low latency is critical. Wi-Fi 7’s target wake time (TWT) and multi-access point coordination features are designed to minimize latency and reduce interference, ensuring smooth, real-time interactions.
                </p><br />
                <p className='fs-6' data-aos="fade-right" data-aos-delay="100">


                    <span style={{ color: "#7F3E98" }}>
                        4. Cloud Gaming:</span> <br />

                    With the increasing number of devices connected to a single network (smart homes, IoT devices, etc.), Wi-Fi 7 is built to manage more connected devices without a decline in performance. It optimizes how it schedules communication with devices to ensure that everyone gets a piece of the bandwidth efficiently, even in high-density environments.
                </p> <br />
                <p className='fs-6' data-aos="fade-right" data-aos-delay="100">


                    <span style={{ color: "#7F3E98" }}>
                        5. Enterprise Connectivity and Remote Work:</span> <br />
                    Wi-Fi 7 introduces new ways of utilizing the spectrum more effectively. Coloring schemes and coordinated beamforming allow for better spatial reuse of channels, reducing interference and maximizing spectrum efficiency. These techniques enable networks to handle more users and devices simultaneously without significant performance drops.
                </p> <br />
                <img src='/wifi3.png' data-aos="fade-right" data-aos-delay="100" className='w-100' alt='wifi3' /> <br />
                <p className='fs-6' data-aos="fade-right" data-aos-delay="100">

                    <span style={{ color: "#7F3E98" }}> Hardware Upgrades:</span> <br />
                    Current devices (smartphones, laptops, routers) are not compatible with Wi-Fi 7, meaning that consumers and businesses will need to invest in new hardware to take advantage of its benefits.
                </p> <br />
                <p className='fs-6' data-aos="fade-up" data-aos-delay="100">
                    <span style={{ color: "#7F3E98" }}>  Regulatory Approval:  </span> <br />

                    As Wi-Fi 7 makes use of the 6 GHz band, regulatory approval from different regions will be necessary to ensure its global rollout. Some countries may take longer to open the required spectrum for public use.

                </p> <br />
                <p className='fs-6' data-aos="fade-right" data-aos-delay="100">


                    <span style={{ color: "#7F3E98" }}>  Cost: </span> <br />


                    As with any new technology, early adopters of Wi-Fi 7 hardware will likely face higher prices until economies of scale drive costs down.


                </p>
            </div>
            <div className='' style={{ paddingLeft: "6%", background: "#262626" }}>


                <div className='container ' >

                    <div className='row' >
                        <div className='col-lg-6' data-aos="fade-right" data-aos-delay="100">

                            <h2 className='text-start fs-2 mt-5 para fw-bold text-light'>The Future with
                                Wi-Fi 7
                            </h2> <br />
                            <p className='w-100 text-light'>Wi-Fi 7 promises to reshape how we connect to the digital world, from improving everyday internet experiences to enabling the technologies of the future. As industries like entertainment, education, healthcare, and telecommunications increasingly rely on wireless infrastructure, Wi-Fi 7's high throughput, low latency, and enhanced connectivity will be the backbone of next-gen digital services. As the technology matures, we can expect to see Wi-Fi 7 becoming the new standard in homes, offices, and smart cities around the globe, driving innovation and connectivity forward in unprecedented ways.

                            </p>  <br /><br />
                        </div>
                        <div className='col-lg-5  mx-1' data-aos="fade-up" data-aos-delay="100">
                            <img src='/wifi4.png' className='' alt='wifi4' />
                        </div>
                    </div>
                </div>

            </div>
            <Demo />
        </div>
    )
}

export default Wifi